import { DripContactOptOutRequest, DripContactOptOutResponse } from '../types';
import axiosInstance from './axiosInstance';

export async function optOutDripContact(uuid: string, req: DripContactOptOutRequest) {
  const response = await axiosInstance.post(`/drip/contacts/${uuid}/opt-out`, req);
  return response.data as DripContactOptOutResponse;
}
